"use client"
import { ActionIcon, Menu, Overlay } from "@mantine/core"
import { useDebouncedState, useHover } from "@mantine/hooks"
import { useEffect } from "react"

import { cn } from "@/lib/utils"
import { useAppStore } from "@/app/(store)/appStore"

interface NavbarButtonWithMenuProps {
  isSelected: boolean
  isSidebarMenuExpanded: boolean
  icon: any
  children: React.ReactNode
}

export function NavbarButtonWithMenu({
  isSelected,
  isSidebarMenuExpanded,
  icon: Icon,
  children,
}: NavbarButtonWithMenuProps) {
  const { hovered, ref } = useHover()
  const [debouncedHovered, setDebouncedHovered] = useDebouncedState(false, 100)

  useEffect(() => {
    setDebouncedHovered(hovered)
  }, [hovered, setDebouncedHovered])

  return (
    <>
      <div
        className={cn(
          "flex items-center justify-center",
          isSidebarMenuExpanded ? "ml-2 w-full justify-start gap-2" : "center"
        )}
        ref={ref}
      >
        <Menu
          trigger="hover"
          loop={false}
          withinPortal={false}
          trapFocus={false}
          menuItemTabIndex={0}
          position="right-start"
          withArrow
          zIndex={8001}
          shadow="lg"
        >
          <Menu.Target>
            <ActionIcon
              variant={
                isSidebarMenuExpanded && (hovered || debouncedHovered)
                  ? "light"
                  : isSelected
                    ? "white"
                    : "transparent"
              }
              color={isSelected ? "blue" : "gray.3"}
              size="lg"
              radius="md"
              className={cn(
                "!min-h-[36px] !min-w-[36px]",
                isSidebarMenuExpanded ? "!hidden" : ""
              )}
              style={{
                zIndex:
                  isSidebarMenuExpanded && (hovered || debouncedHovered)
                    ? 8001
                    : 10,
              }}
            >
              <Icon style={{ width: "60%", height: "60%" }} stroke={1.5} />
            </ActionIcon>
          </Menu.Target>
          {children}
        </Menu>
      </div>
      {isSidebarMenuExpanded && (hovered || debouncedHovered) && (
        <Overlay backgroundOpacity={0.55} blur={3} fixed zIndex={8000} />
      )}
    </>
  )
}
